module.exports = __webpack_public_path__ + "static/img/name3.b02f773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cn/name3.png
// module id = 7RrE
// module chunks = 1